module.exports = __webpack_public_path__ + "static/media/arrow-right-black.60d101fb.svg";